import React from "react"
import styled from "styled-components"
import Choice from "../molecules/choice"
import media from "styled-media-query"

const Wrap = styled.div`
  font-size: 12px;
  margin: 18px 0;
  ${media.greaterThan("small")`
    margin: 26px 0;
  `}
`
const StyledA = styled.a`
  cursor: pointer;
`
const StyledEl = styled.div`
  height: 47px;
  ${media.greaterThan("small")`
    height:64px;
  `}
`

const ChoiceList = props => {
  const elementList = props.elements
  const func = props.func

  return (
    <Wrap>
      {elementList.map((element, index) => {
        return (
          <StyledEl key={index}>
            <StyledA onClick={() => func(element)}>
              <Choice element={element} func={func} />
            </StyledA>
          </StyledEl>
        )
      })}
    </Wrap>
  )
}

export default ChoiceList
